export var CardTrackingStatus;
(function (CardTrackingStatus) {
    CardTrackingStatus["CREATED"] = "CREATED";
    CardTrackingStatus["DISPATCHED"] = "DISPATCHED";
    CardTrackingStatus["IN_TRANSIT"] = "IN_TRANSIT";
    CardTrackingStatus["OUT_FOR_DELIVERY"] = "OUT_FOR_DELIVERY";
    CardTrackingStatus["DELIVERY_ISSUE_UNDER_INVESTIGATION"] = "DELIVERY_ISSUE_UNDER_INVESTIGATION";
    CardTrackingStatus["DELIVERED"] = "DELIVERED";
    CardTrackingStatus["DELIVERY_FAILED"] = "DELIVERY_FAILED";
    CardTrackingStatus["CANCELLED"] = "CANCELLED";
})(CardTrackingStatus || (CardTrackingStatus = {}));
